import { createLogic } from 'redux-logic';
import { push as pushAction, replace as replaceAction } from 'connected-react-router';
import { captureMessageInSentry } from 'lib/captureInSentry';
import * as actions from './actions';

const goToBookingDetailsLogic = createLogic({
  type: actions.goToBookingDetails,
  async process({ action }, dispatch, done) {
    const { bookingId, replace = false } = action.payload || {};

    if (bookingId) {
      const path = `/bookings/${bookingId}`;
      dispatch(replace ? replaceAction(path) : pushAction(path));
    } else {
      captureMessageInSentry(`Booking id not found when attempting to navigate to current booking's detail page`);
    }

    done();
  },
});

export default [goToBookingDetailsLogic];
